module.exports = __webpack_public_path__ + "static/media/student_icon.ec8dd305.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/student_icon.svg
// module id = 237
// module chunks = 0